import { doc, getDoc } from 'firebase/firestore';

import { db } from '@src/firebase/firebase';
import BarChart from '@src/models/BarChart';
import { ACTIONS } from '@src/util/firebase-operations/constants';
import {
  getRouteToBarChartByDivision,
  getRouteToBarChartByOrg,
} from '@src/util/firebase-operations/constants';
import { createOperation } from '@src/util/firebase-operations/utils/createOperation';
import safeExecute from '@src/util/safeExecute';

class BarChartRepository {
  constructor() {
    this.barChart = new BarChart();
  }

  getCollectionPath(orgId, divId = null, boardId) {
    if (divId) {
      return getRouteToBarChartByDivision(orgId, divId, boardId);
    }
    return getRouteToBarChartByOrg(orgId, boardId);
  }

  async create({ data, orgId, divId = null, boardId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.barChart.setData(data);
      const res = await createOperation(collectionPath, null, this.barChart, ACTIONS.CREATE);
      return res;
    }).catch(error => {
      throw error;
    });
  }

  async update({ data, orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      this.barChart.setData(data);
      const barChartData = this.barChart.toUpdate();
      await createOperation(collectionPath, chartId, barChartData, ACTIONS.UPDATE);
      return barChartData;
    }).catch(error => {
      throw error;
    });
  }

  async delete({ orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      await createOperation(collectionPath, chartId, null, ACTIONS.DELETE);
      return { id: chartId };
    }).catch(error => {
      throw error;
    });
  }

  async get({ orgId, divId = null, boardId, chartId }) {
    return safeExecute(async () => {
      const collectionPath = this.getCollectionPath(orgId, divId, boardId);
      const barChartRef = doc(db, collectionPath, chartId);
      const barChartDoc = await getDoc(barChartRef);
      
      if (barChartDoc.exists()) {
        return { id: barChartDoc.id, ...barChartDoc.data() };
      }
      return null;
    }).catch(error => {
      throw error;
    });
  }
}

export default BarChartRepository;
